const ACCENTED = {
    a: 'á', e: 'é', i: 'í', o: 'ö', u: 'ü', c: 'ç', n: 'ñ', s: 'š', y: 'ý', z: 'ž',
    A: 'Å', E: 'É', I: 'Î', O: 'Ö', U: 'Ü', C: 'Ç', N: 'Ñ', S: 'Š', Y: 'Ý', Z: 'Ž'
};

// Interpolations and nesting are keys, not text, so they pass through untouched.
const TOKENS = /(\{\{[^}]*\}\}|\$t\([^)]*\))/;

const pseudoString = (text) => {
    const body = text
        .split(TOKENS)
        .map((part, i) => (i % 2 ? part : [...part].map(c => ACCENTED[c] || c).join('')))
        .join('');
    // French and Spanish run 20-30% longer than English; pad by that much.
    return `[${body}${'~'.repeat(Math.ceil(text.length * 0.3))}]`;
};

// The whole English bundle, pseudo-localised with the same shape and keys.
export const pseudoLocalise = (node) => (typeof node === 'string'
    ? pseudoString(node)
    : Object.fromEntries(Object.entries(node).map(([key, value]) => [key, pseudoLocalise(value)])));
